import React from 'react'
import SignupForm from '../components/authform/signupform'
import girsimage from '../pages/images/allLogo.png'
import whatsappicon from '../pages/images/whatsapp.png'
import phoneicon from '../pages/images/phone-call.png'
import chaticon from '../pages/images/chat.png'
import mailicon from '../pages/images/mail.png'
import chat2icon from '../pages/images/chat (2).png'
import chat3icon from '../pages/images/speech-bubble.png'

function Signup() {
    return (
        <>
            <div className='w-full min-h-screen overflow-hidden bg-[radial-gradient(at_10%_90%,rgba(55,65,81,0.4),transparent),linear-gradient(206deg,#326ea0_0%,#3fc5aa_41%,#2eff95_68%)] flex flex-col lg:flex-row justify-between items-center px-6 lg:px-14 py-6 gap-10'>

                <SignupForm />
                <div className='bg-center bg-origin-content bg-no-repeat'
                    style={{ backgroundImage: `url(${girsimage})` }}
                >
                    <div className="w-[300px] h-[300px] sm:w-[400px] sm:h-[400px] md:w-[500px] md:h-[500px] lg:w-[600px] lg:h-[600px] border-[#fff] border-[2px] rounded-full relative flex items-center justify-center animate-spin-slow1">

                        <img
                            className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] absolute -top-5 left-1/2 -translate-x-1/2"
                            src={whatsappicon}
                            alt=""
                        />
                        <img
                            className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] absolute -bottom-5 right-1/2 -translate-x-1/2"
                            src={phoneicon}
                            alt=""
                        />

                        <div className="w-[250px] h-[250px] sm:w-[350px] sm:h-[350px] md:w-[450px] md:h-[450px] lg:w-[500px] lg:h-[500px] border-[#fff] border-[2px] rounded-full relative flex items-center justify-center animate-spin-slow2">

                            <img
                                className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] absolute -top-5 left-1/2 -translate-x-1/2"
                                src={chaticon}
                                alt=""
                            />

                             <img
                            className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] absolute -bottom-5 right-1/2 -translate-x-1/2"
                            src={mailicon}
                            alt=""
                        />

                            <div className="w-[200px] h-[200px] sm:w-[300px] sm:h-[300px] md:w-[400px] md:h-[400px] lg:w-[400px] lg:h-[400px] border-[#fff] border-[2px] rounded-full relative flex items-center justify-center animate-spin-slow3 ">

                                <img
                                    className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] absolute -top-5 left-1/2 -translate-x-1/2"
                                    src={chat2icon}
                                    alt=""
                                />

                                 <img
                            className="w-[40px] h-[40px] sm:w-[50px] sm:h-[50px] absolute -bottom-5 right-1/2 -translate-x-1/2"
                            src={chat3icon}
                            alt=""
                        />

                            </div>
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}

export default Signup
